//
// Generated class IntegratorMappingKey
//

/// <reference path="IntegratorMappingKey_ManagedObject.ts" />

class IntegratorMappingKey extends IntegratorMappingKey_ManagedObject
{

}
